import { render, staticRenderFns } from "./VariantGroupsForm.vue?vue&type=template&id=0b6ec5b2&scoped=true&"
import script from "./VariantGroupsForm.vue?vue&type=script&lang=js&"
export * from "./VariantGroupsForm.vue?vue&type=script&lang=js&"
import style0 from "./VariantGroupsForm.vue?vue&type=style&index=0&id=0b6ec5b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ec5b2",
  null
  
)

export default component.exports